import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Trademark = styled(Typography)(() => ({
  display: "inline-block",
  marginLeft: ".1em",
  verticalAlign: "super",
  fontSize: ".8em",
  marginTop: "-1em",
}));
